import React, { useEffect, useState } from 'react'
import { useForm, useFieldArray, useWatch, Controller } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../redux/actions'
import { Link, useParams, useHistory } from 'react-router-dom'
import BackButton from 'components/Button/BackButton'
import RGL, { WidthProvider } from 'react-grid-layout'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import api from '../../../util/api'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import UserRoles from '../../../config/UserRoles'

// components
import { Button, Collapse, IconButton, Link as LinkUI } from '@chakra-ui/react'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import DiagramRenderingComponent from '../../../components/Diagram/Function/DiagramRenderingComponent'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

export default function DiagramGroup({ sidebarStatus, setIsShowSidebar }) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [currentStation, setcurrentStation] = useState()
  const [currentGroup, setcurrentGroup] = useState()
  const [isFetchNewOne, setisFetchNewOne] = useState(true)
  const dispatch = useDispatch()
  const params = useParams()
  const allStations = useSelector((state) => state.station)
  const me = useSelector((state) => state.me)
  const [priority, setPriority] = useState()
  const [priDiagram, setPriDiagram] = useState()
  const ReactGridLayout = WidthProvider(RGL)
  const [layout, setLayout] = useState()
  const [activeTab, setActiveTab] = useState()
  const [Sg, setSG] = useState([])
  const vasibleTabs = 3
  const [startIndex, setStartIndex] = useState(0)
  const handlePrev = () => {
    setStartIndex(startIndex - 1)
  }
  const handleNext = () => setStartIndex(startIndex + 1)

  const { control, watch, setValue, handleSubmit } = useForm({
    defaultValues: {},
  })

  const { fields } = useFieldArray({
    control,
    name: 'diagram',
  })

  useEffect(() => {
    const fetchStationData = async () => {
      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/station/${params.stationId}`
        )
        //console.log('Request Server to Get Station Data')
        if (res.data) {
          setcurrentStation(res.data)
          setIsLoading(true)
          setisFetchNewOne(false)
        }
      } catch (error) {
        console.error('Error fetching station data:', error)
      }
    }

    fetchStationData()
  }, [params.stationId, params.groupId, isFetchNewOne])

  useEffect(() => {
    if (allStations?.arr?.length) {
      const tempStation = _.find(
        allStations.arr,
        (station) => station._id === params.stationId
      )
      setcurrentStation(tempStation)
      setIsLoading(true)
    }
  }, [params.stationId, params.groupId, me])

  useEffect(() => {
    if (currentStation) {
      const tempGroup = _.find(
        currentStation.groups,
        (group) => group._id === params.groupId
      )
      setcurrentGroup(tempGroup)
      setActiveTab(tempGroup?.groupName)
      const tempPriority = _.find(
        currentStation.priority,
        (prior) => prior.role === me.role
      )
      setPriority(tempPriority)

      if (tempPriority) {
        const orderedDiagrams = _.compact(
          _.map(tempPriority.diagram, (diagramId) =>
            _.find(currentStation.diagrams, (dia) => dia._id === diagramId)
          )
        )
        setPriDiagram(orderedDiagrams)

        setValue('diagram', orderedDiagrams)
      }
    }
  }, [currentStation, params.stationId, params.groupId])

  useEffect(() => {
    if (isFetchNewOne === false) {
      setTimeout(() => {
        setisFetchNewOne(true)
      }, 30000)
    }
    return () => {}
  }, [isFetchNewOne])

  useEffect(() => {
    if (currentGroup && priDiagram.length > 0) {
      const tempSG = _.filter(priDiagram, (gg) =>
        currentGroup.diagram.includes(gg._id)
      )
      setSG(tempSG)
      const layoutSet = tempSG.map((dia, index) => ({
        i: index.toString(),
        x: dia.axisX,
        y: dia.axisY,
        w: dia.width,
        h: dia.height,
        minW: dia.width, // Set minW to the actual width
        minH: dia.height, // Set minH to the actual height
        maxW: dia.width, // Optionally set maxW to prevent resizing
        maxH: dia.height, // Optionally set maxH to prevent resizing
      }))
      setLayout(layoutSet)
    }
  }, [
    currentGroup,
    priDiagram,
    params.stationId,
    params.groupId,
    isFetchNewOne,
  ])

  const genDiagramList = () => {
    return (
      <div
        //className="overflow-auto overscroll-auto"
        style={{ minWidth: '1200px' }} //Edit for responsive
      >
        {' '}
        {/*Updated width, max-w-full */}
        <ReactGridLayout
          className="layout h-4/6"
          layout={layout}
          cols={18}
          rowHeight={50}
          width={800}
          // autoSize={false}
          isResizable={false}
          isDraggable={false}
          useCSSTransforms={false}
          // breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }} // removed all breakpoints
          breakpoints={{ lg: 800 }} // set only one breakpoint for desktop size
          maxRows={Infinity}
        >
          {_.map(layout, (item, i) =>
            Sg.length !== 0 ? (
              <div
                key={i}
                className={`bg-gray-500  grid grid-cols-1 text-center rounded-sm shadow-lg text-bold`} // Removed min-w-800px
              >
                {Sg[i]?.attribute[0].isShowLabel
                  ? Sg[i]?.attribute[0].label
                  : ''}
                <DiagramRenderingComponent
                  layout={item}
                  attributeData={Sg[i]?.attribute[0]}
                  stationData={currentStation}
                  diagramData={Sg[i]}
                  display={false}
                />
              </div>
            ) : (
              <></>
            )
          )}
        </ReactGridLayout>
      </div>
    )
  }

  const findGroup = () => {
    let groupList = [] // กลุ่มที่อนุญาติให้เห็น
    if (me?.role === UserRoles.ROLES.USER) {
      groupList = _.filter(
        currentStation?.groups,
        (g) => g.role === UserRoles.ROLES.USER
      )
    } else if (me?.role === UserRoles.ROLES.ADMIN) {
      groupList = _.filter(
        currentStation?.groups,
        (g) =>
          g.role === UserRoles.ROLES.ADMIN || g.role === UserRoles.ROLES.USER
      )
    } else if (me?.role === UserRoles.ROLES.MANAGER) {
      groupList = _.filter(
        currentStation?.groups,
        (g) =>
          g.role === UserRoles.ROLES.USER ||
          g.role === UserRoles.ROLES.ADMIN ||
          g.role === UserRoles.ROLES.MANAGER
      )
    } else if (me?.role === UserRoles.ROLES.SUPER_USER) {
      groupList = currentStation?.groups
    }
    return _.map(
      groupList.slice(startIndex, startIndex + vasibleTabs),
      (group, index) => {
        return (
          <Link
            to={
              '/dashboards/diagramgroup/' + currentStation._id + '/' + group._id
            }
          >
            <Button
              key={index}
              // colorScheme="gray"
              className={`flex-1 text-center text-lg font-medium border-b-4 transition-all duration-300  ${
                activeTab === group.groupName
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500'
              }`}
              onClick={() => setActiveTab(group.groupName)}
            >
              {group.groupName}
            </Button>
          </Link>
        )
      }
    )
  }

  return isLoading && currentStation && Sg ? (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
              {t('dashboard.flowchart')}
            </h6>
            <h2 className="text-gray-800 text-2xl font-bold  font-sans">
              {t('dashboard.flowchart')}
              {currentStation.name}
            </h2>
          </div>
        </div>
        <Button>
          <BackButton />
        </Button>
      </div>
      <div className="flex flex-auto justify-center gap-1">
        <IconButton
          icon={<ChevronLeft />}
          isDisabled={startIndex === 0}
          onClick={handlePrev}
        />
        {findGroup()}
        <IconButton
          icon={<ChevronRight />}
          isDisabled={
            startIndex + vasibleTabs <= currentGroup?.length - vasibleTabs
          }
          onClick={handleNext}
        />
      </div>
      <div className="flex justify-between p-4 ">
        <h2 className="text-gray-800 text-xl px-10 font-bold font-sans">
          กลุ่ม {currentGroup?.groupName}
        </h2>
        <div className="flex justify-items-end">
          <Button
            colorScheme="gray"
            variant="solid"
            size="sm"
            onClick={() => setIsShowSidebar(!sidebarStatus)}
          >
            {t('dashboard.toggleSidebar')}
          </Button>
        </div>
      </div>
      <div
        className="bg-gray-500 p-10 m-6 overflow-x-auto"
        style={{ minWidth: '1200px' }}
      >
        {' '}
        {/*Updated width*/}
        {genDiagramList()}
      </div>
    </div>
  ) : (
    <SpinnerLoading />
  )
}
